<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {socketUrl} from '@/utils/index'

export default {
  name: 'App',
  data() {
    return {
      socket: null,
      socketUrl: socketUrl,
      num: 0, //websocket连接次数
      timer: null
    }
  },
  created() {
    // WebSocket
    this.longLink()
    this.$Bus.$on('class_change', val => {
      let message
      if (val.type == 1) {
        // 上课
        message = 'on,' + val.bjid
      } else if (val.type == 2) {
        // 下课
        message = 'off,' + val.bjid
      }
      this.socket.send(message)
    })
    this.$Bus.$on('lock_change', val => {
      let message
      if (val.type == 1) {
        // 解屏
        message = 'on,' + val.bjid
      } else if (val.type == 0) {
        // 锁屏
        message = 'off,' + val.bjid
      }
      console.log(message)
      this.socket.send(message)
    })
    // 点击重新连接
    this.$Bus.$on('reconnect', val => {
      this.longLink()
    })
  },
  watch: {
    $route(to, from) {
      console.log(to.path,11111)
      if (to.path !== '/studyway') {
        this.$lock('off')
      }
    }
  },
  methods: {
    // websocket建立连接
    longLink() {
      this.$nextTick(() => {
        this.socket = new WebSocket(`${this.socketUrl}?token=${encodeURIComponent(this.$store.state.token)}&yhid=${this.$store.state.userInfo.yhid}`)
        this.$store.commit('setSock', this.socket)
        this.socket.onopen = this.socketOpen
        this.socket.onclose = this.socketClose
        this.socket.onmessage = this.socketMessage
      })
    },
    // 连接成功
    socketOpen() {
      console.log('websocket连接成功')
      this.num = 0
      this.$store.commit("setSocket", 1)
      clearInterval(this.timer)
    },
    // 关闭连接
    socketClose() {
      if (this.num >= 3) {
        if (JSON.parse(sessionStorage.getItem('userInfo')).jsmc == '学生') {
          this.$message({
            showClose: true,
            message: '当前网络故障，请刷新后重试',
            type: 'error',
            duration: 0
          });
        }
        clearTimeout(this.timer)
        return false
      }
      if (this.num < 3) {
        this.timer = setTimeout(() => {
          this.num++
          this.longLink()
        }, 1000)
      }
      this.socket = null
      this.$store.commit("setSocket", 0)
      console.log('websocket连接关闭')
    },
    // 消息接收
    socketMessage(msg) {
      console.log(msg)
      this.num = 0
      clearTimeout(this.timer)
      this.$Bus.$emit('lock', msg.data)
    },
  }
}
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
